// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IVector3 {
	x: number;

	y: number;

	z: number;

	$type?: string | undefined;
}
export class Vector3 {
	constructor(data?: IVector3) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	x: number = 0;

	y: number = 0;

	z: number = 0;

	static $type: string = "System.Numerics.Vector3, ";
	$type?: string | undefined = Vector3.$type;
}

